import { render, staticRenderFns } from "./ConfirmSwitchCourse.vue?vue&type=template&id=800f074a&scoped=true"
import script from "./ConfirmSwitchCourse.vue?vue&type=script&lang=ts"
export * from "./ConfirmSwitchCourse.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmSwitchCourse.vue?vue&type=style&index=0&id=800f074a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800f074a",
  null
  
)

export default component.exports